export enum GridAvailability {
  hours = 'hours',
  percentage = 'percentage',
  complex = 'complex'
}
